import React,{ useState, useEffect , useRef} from 'react';
import { downloadCsv } from '../common/sharedFunctions';
import MaterialTable from "material-table";
import CircularLoading from "../components/CircularLoading";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import {colors} from '../components/Theme/WebTheme';

const Sos = () => {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const loaded = useRef(false);


  const columns =  [
    { title: t('id'), field: 'bookingId',editable: 'never'},
    { title: t('user_name'),field: 'user_name',editable: 'never'},
    { title: t('contact'),field: 'contact', render: rowData => settings.AllowCriticalEditsAdmin ? rowData.contact : "Hidden for Demo", editable: 'never'},
    { title: t('user_type'),field: 'user_type',editable: 'never'},
    { title: t('complainDate'), field: 'complainDate', editable:'never', defaultSort:'desc',render: rowData => rowData.complainDate? moment(rowData.complainDate).format('lll'):null},
    {
      title: t('gps_coordinates') || 'GPS Coordinates',
      field: 'location',
      editable: 'never',
      render: rowData => {
        let lat = rowData.latitude || (rowData.coords && rowData.coords.lat);
        let lng = rowData.longitude || (rowData.coords && rowData.coords.lng);
        if ((lat === undefined || lat === null || lng === undefined || lng === null) && rowData.location) {
          const parts = String(rowData.location).split(',');
          if (parts.length === 2) {
            lat = parts[0].trim();
            lng = parts[1].trim();
          }
        }
        if (lat !== undefined && lat !== null && lng !== undefined && lng !== null && lat !== '' && lng !== '') {
          const displayLat = typeof lat === 'number' ? lat.toFixed(6) : lat;
          const displayLng = typeof lng === 'number' ? lng.toFixed(6) : lng;
          return (
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={e => e.stopPropagation()}
              style={{
                color: '#1976d2',
                textDecoration: 'none',
                fontWeight: 600,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}
              title={t('open_in_google_maps') || 'Open in Google Maps'}
            >
              <span role="img" aria-label="location">📍</span> {displayLat}, {displayLng}
            </a>
          );
        }
        return '-';
      }
    }
  ];
  const [data, setData] = useState([]);
  const sosdata = useSelector(state => state.sosdata);

  useEffect(()=>{
        if(sosdata.sos){
            setData(sosdata.sos.map(item => {
              const lat = item.latitude || (item.coords && item.coords.lat);
              const lng = item.longitude || (item.coords && item.coords.lng);
              const locStr = item.location ? item.location : (lat && lng ? `${lat}, ${lng}` : '');
              return {
                ...item,
                location: locStr
              };
            }));
        }else{
          setData([]);
        }
        loaded.current = true;
  },[sosdata.sos]);

  const [selectedRow, setSelectedRow] = useState(null);
  
  return (
    !loaded.current? <CircularLoading/>:
    <MaterialTable
      title={t('sos')}
      columns={columns}
      style={{direction:isRTL ==='rtl'?'rtl':'ltr',  borderRadius: "8px", boxShadow: "4px 4px 6px #9E9E9E"}}
      data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={{
        pageSize:10,
        pageSizeOptions:[10,15,20],
        exportCsv: (columns, data) => {
          let hArray = [];
          const headerRow = columns.map(col => {
            if (typeof col.title === 'object') {
              return col.title.props.text;
            }
            hArray.push(col.field);
            return col.title;
          });
          const dataRows = data.map(({ tableData, ...row }) => {
            row.complainDate = row.complainDate ? moment(row.complainDate).format('lll') : (row.date ? new Date(row.date).toLocaleDateString() + ' ' + new Date(row.date).toLocaleTimeString() : '');
            row.processDate = row.processDate ? new Date(row.processDate).toLocaleDateString() + ' ' + new Date(row.processDate).toLocaleTimeString() : '';
            let dArr = [];
            for(let i=0;i< hArray.length; i++) {
              let val = row[hArray[i]];
              if (val === undefined || val === null) val = '';
              dArr.push(`"${String(val).replace(/"/g, '""')}"`);
            }
            return dArr;
          });
          const { exportDelimiter } = ",";
          const delimiter = exportDelimiter ? exportDelimiter : ",";
          const csvContent = [headerRow.map(h => `"${String(h).replace(/"/g, '""')}"`), ...dataRows].map(e => e.join(delimiter)).join("\n");
          const csvFileName = 'download.csv';
          downloadCsv(csvContent, csvFileName);
        },
        exportButton: {
          csv: settings.AllowCriticalEditsAdmin,
          pdf: false,
        },
        rowStyle: rowData => ({
          backgroundColor: (selectedRow === rowData.tableData.id) ? '#EEE' : '#FFF'
        }),
        editable:{
          backgroundColor: colors.Header_Text,
          fontSize: "0.8em",
          fontWeight: 'bold ',
          fontFamily: 'Lucida Console", "Courier New", monospace'
        },
        cellStyle:{
          border: "1px solid rgba(224, 224, 224, 1)",
          textAlign:'center'
        },
        headerStyle: {
          position: "sticky",
          top: "0px",
          backgroundColor: colors.SECONDARY ,
          color: '#fff',
          fontSize: "0.8em",
          fontWeight: 'bold ',
          fontFamily: 'Lucida Console", "Courier New", monospace',
          border: "1px solid rgba(224, 224, 224, 1)",
          textAlign:'center'
        }
      }}
      localization={{
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
        },
        header: {
          actions: (t('actions')) 
      },
      pagination: {
        labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
        firstTooltip: (t('first_page_tooltip')),
        previousTooltip: (t('previous_page_tooltip')),
        nextTooltip: (t('next_page_tooltip')),
        lastTooltip: (t('last_page_tooltip'))
      },
      }}
    />
  );
}

export default Sos;